import { createApi } from "./common";

export const searchProducts = createApi("GET", "products/");

export default searchProducts;
